(function () {
  'use strict';

  var isIOS = /iPod|iPhone|iPad/i.test(window.navigator.userAgent);

  if (isIOS) {
    document.body.classList.add('is-os');
  }

  // Facebook Pixel loader and basic pageview tracking.
  if (!window.fbq) {
    (function (f, b, e, v, n, t, s) {
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  }

  window.fbq('init', '1160736360957878');
  window.fbq('track', 'PageView');

  // Microsoft UET tag.
  (function (w, d, t, r, u) {
    var n;
    var i;
    var f = function () {
      var o = { ti: '56359234' };
      o.q = w[u];
      w[u] = new UET(o);
      w[u].push('pageLoad');
    };

    w[u] = w[u] || [];
    n = d.createElement(t);
    n.src = r;
    n.async = 1;
    n.onload = n.onreadystatechange = function () {
      var s = this.readyState;
      if (!s || s === 'loaded' || s === 'complete') {
        f();
        n.onload = n.onreadystatechange = null;
      }
    };
    i = d.getElementsByTagName(t)[0];
    i.parentNode.insertBefore(n, i);
  })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');

  // Reddit pixel.
  (function (w, d) {
    if (w.rdt) return;
    var p = (w.rdt = function () {
      p.sendEvent ? p.sendEvent.apply(p, arguments) : p.callQueue.push(arguments);
    });
    var t = d.createElement('script');
    var s = d.getElementsByTagName('script')[0];

    p.callQueue = [];
    t.src = 'https://www.redditstatic.com/ads/pixel.js';
    t.async = true;
    s.parentNode.insertBefore(t, s);
  })(window, document);

  window.rdt('init', 't2_a1oyfurg');
  window.rdt('track', 'PageVisit');

  // Non-iOS only, guarded to avoid runtime errors when fish/parallax vars do not exist.
  if (!isIOS && typeof window.parallaxbubbles === 'function') {
    window.addEventListener(
      'scroll',
      function () {
        window.requestAnimationFrame(window.parallaxbubbles);
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      function () {
        if (!window.fish || typeof window.scrollheight === 'undefined' || typeof window.windowheight === 'undefined') {
          return;
        }

        var scrollTop = window.pageYOffset;
        var scrollAmount = (scrollTop / (window.scrollheight - window.windowheight)) * 100;
        window.fish.style.left = -100 + scrollAmount + '%';
      },
      { passive: true }
    );
  }
})();
